import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { QueryHighlight } from '../../types';
import type { QueryHighlightModel } from '../query-highlight-model';

@injectable()
export class QueryHighlightModelImpl extends AbstractModel<QueryHighlight> implements QueryHighlightModel {
    protected _modelData: QueryHighlight = [];
}
